import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42daf011"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/icons/128x128.png" }, null, -1))
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_back_link_button = _resolveComponent("back-link-button")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_resize_observer = _resolveComponent("q-resize-observer")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "lHh Lpr lFf",
    id: "#q-layout"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, {
        elevated: "",
        class: "glossy"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              (_ctx.$route.name === 'Home')
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    flat: "",
                    dense: "",
                    round: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leftDrawerOpen = !_ctx.leftDrawerOpen)),
                    "aria-label": "Menu",
                    icon: "menu"
                  }))
                : (_ctx.q.screen.lt.md || !_ctx.leftDrawerOpen)
                  ? (_openBlock(), _createBlock(_component_back_link_button, { key: 1 }))
                  : _createCommentVNode("", true),
              _createVNode(_component_q_toolbar_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t(`routeTitle.${_ctx.$route.name ? String(_ctx.$route.name) : 'Home'}`)), 1)
                ]),
                _: 1
              }),
              (_ctx.$route.name === 'Home')
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 2,
                    flat: "",
                    dense: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.homePopupOpen = !_ctx.homePopupOpen)),
                    "aria-label": "Information",
                    icon: "info"
                  }))
                : (_ctx.$route.name === 'Chakras')
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 3,
                      flat: "",
                      dense: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.chakraPopupOpen = !_ctx.chakraPopupOpen)),
                      "aria-label": "Information",
                      icon: "info"
                    }))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_footer, {
        class: "page-footer",
        modelValue: _ctx.showFooter,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showFooter) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              (_ctx.isHome)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    flat: "",
                    dense: "",
                    label: _ctx.t(`colorTest`),
                    to: "/colortest/"
                  }, null, 8, ["label"]))
                : (_ctx.isColorTest)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {
            _ctx.reset(false);
            _ctx.shuffleColors();
          }),
                      label: _ctx.t('reset'),
                      flat: "",
                      dense: "",
                      disable: !_ctx.showResetButton
                    }, null, 8, ["label", "disable"]))
                  : (_ctx.isResult)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 2,
                        flat: "",
                        dense: "",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {
            _ctx.$router.push('/');
            _ctx.reset(false);
            _ctx.shuffleColors();
          }),
                        ripple: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('home')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
              _createVNode(_component_q_space),
              (_ctx.isHome)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 3,
                    flat: "",
                    dense: "",
                    label: _ctx.t(`chakrasLink`),
                    to: "/chakras/"
                  }, null, 8, ["label"]))
                : (_ctx.isColorTest)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      to: "result/",
                      flat: "",
                      dense: "",
                      label: _ctx.t('result'),
                      disable: !_ctx.showResultButton
                    }, null, 8, ["label", "disable"]))
                  : (_ctx.isResult)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 5,
                        flat: "",
                        dense: "",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => {
            _ctx.$router.back();
            _ctx.reset(false);
            _ctx.shuffleColors();
          }),
                        ripple: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('newTest')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_q_resize_observer, { onResize: _ctx.onResize }, null, 8, ["onResize"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_drawer, {
        modelValue: _ctx.leftDrawerOpen,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.leftDrawerOpen) = $event)),
        mini: !_ctx.leftDrawerOpen || _ctx.miniState,
        "show-if-above": "",
        bordered: "",
        dark: "",
        class: "bg-grey-9"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "bg-primary" }, {
            default: _withCtx(() => [
              (_ctx.q.screen.gt.sm)
                ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                    key: 0,
                    dense: "",
                    flat: ""
                  }, _ctx.miniButtonProps, {
                    ref: "miniButtonRef",
                    onClick: _ctx.morphMiniButton
                  }), null, 16, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_toolbar_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('panelTitle')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.q.screen.gt.sm)
            ? (_openBlock(), _createBlock(_component_q_list, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item, {
                    clickable: "",
                    to: "/"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: "home" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('home')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, {
                    clickable: "",
                    to: "/colortest/"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: "grain" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('colorTest')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, {
                    clickable: "",
                    to: "/chakras/"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: "brightness_high" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('chakrasLink')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item, {
                clickable: "",
                to: "/faq/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "help" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('faq')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                to: "/links/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "language" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('links')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                to: "/parameters"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "settings" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('parameters')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              (_ctx.showInstallChromium)
                ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: 
                _ctx.q.platform.is.desktop ? 'install_desktop' : 'install_mobile'
              
                          }, null, 8, ["name"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_btn, {
                            flat: "",
                            dense: "",
                            label: "INTALL APP",
                            onClick: _ctx.installApplicationChromium
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "mini"]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.homePopupOpen,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.homePopupOpen) = $event)),
        persistent: "",
        maximized: _ctx.q.platform.is.mobile ? true : false,
        "transition-show": "slide-up",
        "transition-hide": "slide-down"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_layout, {
            view: "hHh lpr fff",
            container: "",
            class: "bg-black"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_toolbar_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t(`popupTitle`)), 1)
                        ]),
                        _: 1
                      }),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, { class: "bg-white text-primary" }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_page_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_page, { class: "q-pa-md" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { class: "bg-grey-10 text-white" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, { class: "text-center" }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                innerHTML: _ctx.t('welcomeMessage')
                              }, null, 8, _hoisted_3)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "maximized"]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.chakraPopupOpen,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.chakraPopupOpen) = $event)),
        persistent: "",
        maximized: _ctx.q.platform.is.mobile ? true : false,
        "transition-show": "slide-up",
        "transition-hide": "slide-down"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_layout, {
            view: "hHh lpr fff",
            container: "",
            class: "bg-black"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_toolbar_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t(`chakraSystemTitle`)), 1)
                        ]),
                        _: 1
                      }),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, { class: "bg-white text-primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('close')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_page_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_page, { class: "q-pa-md" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { class: "bg-grey-10 text-grey-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, _toDisplayString(_ctx.t('chakraPopup[0]')), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.t('chakraPopup[1]')), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.t('chakraPopup[2]')), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.t('chakraPopup[3]')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "maximized"]),
      _createVNode(_component_q_page_container, {
        style: {"overscroll-behavior":"none"},
        class: _normalizeClass(["bg-black", _ctx.q.platform.is.safari ? 'fixed-top' : ''])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, {
            "style-fn": _ctx.pageStyle,
            style: {"margin-left":"env(safe-area-inset-left)","margin-right":"env(safe-area-inset-right)"}
          }, null, 8, ["style-fn"])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}